const freeShippingBannerClosedAtKey = 'sps.freeShippingBannerClosedAt';
const freeShippingClosedTimeMillis = 2 * 60 * 60 * 1000;
const announcementBar = document.querySelector('[id$="__announcement-bar"]');

const hideNav = () => {
  announcementBar.style.display = 'none';
  window.localStorage.setItem(freeShippingBannerClosedAtKey, new Date().toISOString());
};

const isSpecificProductBarVisible = () => {
  const productBarEl = document.querySelector('[id$="__custom-product-specific-header-bar"]');
  if (!productBarEl) return false;

  const style = window.getComputedStyle(productBarEl);
  return style.display !== 'none';
};

const showFreeShippingBannerIfNeeded = () => {
  const closedAt = window.localStorage.getItem(freeShippingBannerClosedAtKey);
  const isSpecificProductHeaderVisible = isSpecificProductBarVisible();
  const shouldShowBanner =
    !isSpecificProductHeaderVisible &&
    (!closedAt || new Date().getTime() - Date.parse(closedAt) > freeShippingClosedTimeMillis);
  announcementBar.style.display = shouldShowBanner ? 'block' : 'none';
};

window.onload = showFreeShippingBannerIfNeeded;
